import { Component, DoCheck } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of, Subject, switchMap } from 'rxjs';

import isArray from 'lodash-es/isArray';
import { AccountService } from 'app/core';
import { RelatedToType } from '@shared/enums';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './tags-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class TagsFormFieldComponent extends FormFieldComponent implements DoCheck {
  public readonly control = new FormControl<string[]>([]);
  public foundTags: string[] = [];

  private readonly searchTerm$ = new Subject<string>();

  constructor(private _accountService: AccountService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.loadTags();
    this.updateDisabledState();

    this.control.valueChanges.pipe(takeUntilDestroyed(this.dRef)).subscribe((tags) => this.onSave(tags));

    this.searchTerm$
      .pipe(
        takeUntilDestroyed(this.dRef),
        // Caught per request so one failed search doesn't end the stream; the service already reports the error.
        switchMap((term) =>
          this._accountService.getAccountTags(RelatedToType.Project, term).pipe(catchError(() => of({}))),
        ),
      )
      .subscribe((tags) => (this.foundTags = Object.keys(tags ?? {})));
  }

  ngDoCheck(): void {
    this.updateDisabledState();
  }

  onSearch(term: string): void {
    this.searchTerm$.next(term);
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.loadTags();
  }

  private loadTags(): void {
    this.control.setValue(this.parseTags(this.model[this.fieldDef.name]), { emitEvent: false });
  }

  // Stored either as an array or as a comma-separated string.
  private parseTags(value: string | string[] | null | undefined): string[] {
    if (!value) {
      return [];
    }

    return isArray(value) ? [...value] : value.split(',');
  }

  private onSave(tags: string[]): void {
    this.model[this.fieldDef.name] = tags;
    this.update.emit({ [this.fieldDef.name]: tags });
  }

  private updateDisabledState(): void {
    if (this.isDisabled === this.control.disabled) {
      return;
    }

    if (this.isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
